import { useNavigate } from "react-router-dom";

export default function BackButton() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (
      window.history.state &&
      typeof window.history.state.idx === "number" &&
      window.history.state.idx > 0
    ) {
      navigate(-1);
    } else {
      navigate("/", { replace: true });
    }
  };

  return (
    <button onClick={handleBack} className="back-button">
      <span className="back-arrow">&larr;</span> Back
    </button>
  );
}
